const getProductFeatureValueById = (
  externalCf: string,
  featureExternalCfId: string,
  featureGroups: any,
) => {
  const featureGroup = featureGroups?.find(
    (group: any) => group.external_cf_id === externalCf,
  );
  const feature =
    featureGroup &&
    featureGroup.features?.length &&
    featureGroup.features.find(
      (item: any) => item.external_cf_id === featureExternalCfId,
    );

  return feature && feature.value ? feature.value : null;
};

export default getProductFeatureValueById;
